import { Button, Flex, Form, Input } from 'antd';
import { Rule } from 'antd/es/form';
import { FunctionComponent } from 'react';
import Icon from 'utils/icon';

interface SharesStepperProps {
	name: string;
	label: string;
	value: number;
	min?: number;
	max?: number;
	step?: number;
	rules?: Rule[];
	onIncrement: () => void;
	onDecrement: () => void;
	onInput?: (event: any) => void;
}

const SharesStepper: FunctionComponent<SharesStepperProps> = ({
	name,
	label,
	value,
	min = 0,
	max,
	step = 1,
	rules,
	onIncrement,
	onDecrement,
	onInput,
}) => {
	return (
		<Flex vertical justify="center" style={{ width: 'max-content' }}>
			<p className="mb-2 text-center">{label}</p>

			<Flex
				gap={10}
				align="center"
				style={{
					minHeight: 40,
					padding: '5px 10px',
					border: '1px solid #D0D5DD',
					backgroundColor: '#F9FAFB',
					borderRadius: '8px',
					marginBottom: 26,
				}}>
				<Button type="primary" className="h-max" style={{ padding: 5 }} onClick={onDecrement} disabled={value === min}>
					<Icon name="minus" color="#fff" width={12} height={12} />
				</Button>

				<Form.Item name={name} rules={rules} noStyle>
					<Input
						variant="borderless"
						type="number"
						min={min}
						step={step}
						max={max}
						style={{ width: 60, padding: 0, textAlign: 'center' }}
						onInput={onInput}
					/>
				</Form.Item>

				<Button
					type="primary"
					className="h-max"
					style={{ padding: 5 }}
					onClick={onIncrement}
					disabled={max !== undefined && value === max}>
					<Icon name="plus" color="#fff" width={12} height={12} />
				</Button>
			</Flex>
		</Flex>
	);
};

export default SharesStepper;
